import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    gap: 20px;

    overflow-y: scroll;
    height: 470px;

    &::-webkit-scrollbar { 
        width: 5px;
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    &::-webkit-scrollbar-thumb{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        border-radius: 20px;
    }
    
    input[type='text']{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
        }
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
        background-color: transparent;
        padding: 10px;
        width: 100%;
    }
`;

export const FeaturedSection = styled.section`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border-radius: 4px;
    padding: 10px;
`;

export const ContentInfor = styled.div`
    background-color: ${(props) => props.theme.colors.primary_low};
    border-left: 3px solid ${(props) => props.theme.colors.primary};
    border-radius: 4px;
    padding: 5px 10px;
`;

export const SeparateDiv = styled.div`
    display: flex;
    gap: 20px;
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    input{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
        padding: 10px;
        width: 100%;
    }
`;

export const Title = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const LabelGray = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_200};
    font-size: 14px;
    width: 15%;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    background-color: transparent;
    padding: 10px;
    width: 100%;
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    
    padding: 10px 0px;
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const Text = styled.p`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
    &.subtitle{
        font-size: 10px;
    }

    &.title{
        font-weight: 500;
    }
`;